import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import {getPageUrl} from '../lib/helpers'



export const query = graphql`
  query {
    seoQuery: strapi{ siteSetting {
      id
      site_name
      default_seo_description
      featured_pages {
        id
        title
        slug
        page_type {
          name
          slug_prefix
        }
        main_image {
          url
          caption
          alternativeText
          imageFile{
            childImageSharp{
              gatsbyImageData(
                width: 400,
                aspectRatio: 1,
                transformOptions: {cropFocus:ENTROPY})
            }
          }
        }
      }
    }}
}
`


const SEO = ({ title, description, image, article }) => {
  const data = useStaticQuery(query);
  const siteSetting = data.seoQuery.siteSetting;

  const seo = {
    title: title || siteSetting.site_name,
    description: description || siteSetting.default_seo_description,
    image: image
  }

  var title_appended = ` | ` + siteSetting.site_name;
  if ( siteSetting.site_name == "Error Solutions"){
    var title_appended = ` - ` + siteSetting.site_name;
  }

  return (
    <>
    <Helmet 
      title={seo.title + title_appended}
      htmlAttributes={{
        lang: 'en',
      }}>
      <meta name="description" content={seo.description} />
      {seo.image && <meta name="image" content={seo.image} />}

      {seo.url && <meta property="og:url" content={seo.url} />}

      {(article ? true : null) && <meta property="og:type" content="article" />}

      {seo.title && <meta property="og:title" content={seo.title} />}

      {seo.description && (
        <meta property="og:description" content={seo.description} />
      )}

      {seo.image && <meta property="og:image" content={seo.image} />}

      {seo.title && <meta name="twitter:title" content={seo.title} />}

      {seo.description && (
        <meta name="twitter:description" content={seo.description} />
      )}

      {seo.image && <meta name="twitter:image" content={seo.image} />}

      {process.env.GOOGLEANALYTICS_TRACKINGID && 
        <script async src={"https://www.googletagmanager.com/gtag/js?id="+process.env.GOOGLEANALYTICS_TRACKINGID}></script>
      }

      {process.env.ADSENSE_CLIENT_ID && 
        <>
          <script async src={"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client="+process.env.ADSENSE_CLIENT_ID} crossorigin="anonymous"></script>
          <script
            dangerouslySetInnerHTML={{
              __html: `(adsbygoogle = window.adsbygoogle || []).push({});`,
            }}
          />
        </>
      }

    </Helmet>

    {article.parent && 
    <Helmet script={[{
      type:"application/ld+json",
      innerHTML:`
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "`+article.parent.title+`",
        "item": "`+process.env.SITE_URL+getPageUrl(article.parent)+`"
      }]
    }`}]} />
    }
    { (process.env.GOOGLEANALYTICS_TRACKINGID && process.env.GOOGLEANALYTICS4_TRACKINGID ) && 
    <Helmet 
    script={[{ 
      type: 'text/javascript', 
      innerHTML: `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '`+process.env.GOOGLEANALYTICS_TRACKINGID+`');
      gtag('config', '`+process.env.GOOGLEANALYTICS4_TRACKINGID+`');`
    }]}
    />
    }
    </>
  )
}

export default SEO

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  article: PropTypes.bool,
}

SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  article: false,
}
